/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PreOpsChecklistCreate
 */
export interface PreOpsChecklistCreate {
    /**
     * 
     * @type {string}
     * @memberof PreOpsChecklistCreate
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof PreOpsChecklistCreate
     */
    minutesUntilLogout?: number | null;
}

/**
 * Check if a given object implements the PreOpsChecklistCreate interface.
 */
export function instanceOfPreOpsChecklistCreate(value: object): value is PreOpsChecklistCreate {
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function PreOpsChecklistCreateFromJSON(json: any): PreOpsChecklistCreate {
    return PreOpsChecklistCreateFromJSONTyped(json, false);
}

export function PreOpsChecklistCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreOpsChecklistCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'minutesUntilLogout': json['minutesUntilLogout'] == null ? undefined : json['minutesUntilLogout'],
    };
}

export function PreOpsChecklistCreateToJSON(json: any): PreOpsChecklistCreate {
    return PreOpsChecklistCreateToJSONTyped(json, false);
}

export function PreOpsChecklistCreateToJSONTyped(value?: PreOpsChecklistCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'minutesUntilLogout': value['minutesUntilLogout'],
    };
}

